import Field from '..'
import cn from 'classnames'
import { useState } from 'react'
import styles from './index.module.scss'
import { useEffect } from 'react'

export default function FieldSelect({ name, defaultValue, field }) {

    const {
        className,
        required
    } = field

    const [selected, setSelected] = useState(false)
    const [value, setValue] = useState(defaultValue || "")

    useEffect(() => {
        if ( defaultValue ) setValue(defaultValue)
    }, [defaultValue])
    

    const onChange = (val) => setValue(val)

    return (
        <Field field={field} className={cn(styles.field, ((selected || value) && styles.selected), (field.type === 'email' && styles.email))}>
            <label className={styles.label}>{field.label}</label>
            <select 
                type="text" 
                name={name}
                className={cn(className, styles.input)} 
                required={required} 
                onChange={(e) => onChange(e.target.value)}
            >
                <option value=""></option>
                {field.options && field.options.map(item => (
                    <option>{item}</option>
                ))}
            </select>
        </Field>
    )

}